import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { VscFilter } from 'react-icons/vsc';
import { GoTriangleDown } from 'react-icons/go';
import { FiPlus } from 'react-icons/fi';
import Worker_web_protal from '../../../layout/Worker_web_portal';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import { Base_url } from '../../../utils/Base_url';
import { IoSearchOutline } from 'react-icons/io5';
import * as XLSX from 'xlsx'; // Importing xlsx library
import Manager_web_portal from '../../../layout/Manager_web_portal';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import { useAllinvestmentsQuery } from '../../../store/services/investmentService';
import ViewSlip from './ViewSlip';
import { toast } from 'react-toastify';
import moment from 'moment';
import PaginationBar from '../../../components/PaginationBar';
const Collection = () => {
  const { data, isFetching, refetch } = useAllinvestmentsQuery();
  const [searchTerm, setSearchTerm] = useState('');
  const [minValue, setMinValue] = useState('');
  const [maxValue, setMaxValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [filteredDeposits, setFilteredDeposits] = useState([]);
  const manager_data = JSON.parse(localStorage.getItem('manager_data'));
  const [getData, setGetData] = useState({});
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [loading, setLoading] = useState(null);

  // Email verification states
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [enteredCode, setEnteredCode] = useState('');
  const [selectedAckItem, setSelectedAckItem] = useState(null);
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [codeError, setCodeError] = useState('');
  const openModal2 = () => {
    setIsModalOpen2(true);
  };

  const exportToExcel = () => {
    // Get current date
    const date = new Date();
    const month = date.toLocaleString('default', { month: 'long' }); // Get the full month name (e.g., 'January')
    const year = date.getFullYear(); // Get the current year (e.g., '2024')

    // Create the filename with the format Month/Year/Collection.xlsx
    const fileName = `${month}-${year}-Collection.xlsx`;

    const ws = XLSX.utils.json_to_sheet(data?.investments); // Convert the array to a worksheet
    const wb = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1'); // Append the worksheet to the workbook
    XLSX.writeFile(wb, fileName); // Download the file with the specified name
  };

  const closeModal2 = () => {
    setIsModalOpen2(false);
  };

  useEffect(() => {
    filterDeposits();
  }, [data, searchTerm, minValue, maxValue, statusFilter]);

  const toggleDropdown = () => setDropdownVisible(!dropdownVisible);
  // console.log('Data Investment', data?.investments);

  const filterDeposits = () => {
    let filtered = data?.investments?.slice()?.reverse() || [];
    if (searchTerm.trim()) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();

      filtered = filtered.filter((val) => {
        // Convert the depositDate to DD/MM/YYYY

        const depositDate = new Date(val?.depositDate).toLocaleDateString('en-GB');

        const depositDateMatch = depositDate?.toLowerCase().includes(lowercasedSearchTerm);
        const nameMatch = val?.name?.toLowerCase().includes(lowercasedSearchTerm);
        const cnicMatch = val?.cnic?.toLowerCase().includes(lowercasedSearchTerm);
        const cnicId = val?._id?.toLowerCase().includes(lowercasedSearchTerm);

        return depositDateMatch || nameMatch || cnicMatch || cnicId;
      });
    }
    if (minValue || maxValue) {
      const min = parseFloat(minValue) || Number.MIN_SAFE_INTEGER;
      const max = parseFloat(maxValue) || Number.MAX_SAFE_INTEGER;
      filtered = filtered.filter((deposit) => {
        const amount = parseFloat(deposit.amount);
        return amount >= min && amount <= max;
      });
    }

    if (statusFilter) {
      setDropdownVisible(false);
      filtered = filtered.filter((deposit) => {
        if (statusFilter === 'true') {
          return deposit.acknowledgeStatus === true;
        } else if (statusFilter === 'false') {
          return deposit.acknowledgeStatus === false;
        }
        return true; // For "All" or no status selected
      });
    }

    setFilteredDeposits(filtered);
    setCurrentPage(1);
  };

  const currentPageData = filteredDeposits.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const openModalWithItem = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };


  const add_acknowledge = (id) => {
    setLoading(id);
    
    const params = {
      acknowledgeAuth: manager_data?.name,
      acknowledgeDate: moment(Date.now()).format('L'),
      acknowledgeStatus: true
    };

    axios
      .post(`${Base_url}/v1/manager/update-investments/${id}`, params)
      .then((updateRes) => {
        // console.log(updateRes);
        if (updateRes?.data?.success === true) {
          toast.success('Acknowledgment created successfully');
          setLoading(null);
          refetch();
        } else {
          toast.success(updateRes?.data?.message);
          setLoading(null);
        }
      })
      .catch((updateError) => {
        // console.log(updateError);
        setLoading(null);
        toast.error('Failed to update investment');
      });
  };

  const user = localStorage.getItem('manager_data');

  let userData = JSON.parse(user)
  // Log all userData to see available fields

  // Get email - check different possible field names
  const managerEmail = userData?.email || userData?.Email || userData?.managerEmail || userData?.user?.email || '';

  // Generate random 6-digit code
  const generateCode = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  // Handle acknowledge button click - opens verification modal
  const handleAcknowledgeClick = (item) => {
    setSelectedAckItem(item);
    setEnteredCode('');
    setCodeError('');
    setCodeSent(false);
    setIsVerificationModalOpen(true);
  };

  // EmailJS Configuration
  const EMAILJS_SERVICE_ID = 'service_q3lfhfs';
  const EMAILJS_TEMPLATE_ID = 'template_xerw7qb';
  const EMAILJS_PUBLIC_KEY = 'thV8CjwHDlY0XEB1T';

  // Send verification code to email using EmailJS
  const sendVerificationCode = async () => {

    if (!managerEmail) {
      toast.error('No email found for your account. Please check your profile.');
      console.error('No email in userData:', userData);
      return;
    }

    setIsSendingCode(true);
    setCodeError('');

    const code = generateCode();
    setVerificationCode(code);

    try {
      const templateParams = {
        // Try multiple email field names - EmailJS uses different ones
        to_email: "admin@welcomehabibitrading.com",
        email: "admin@welcomehabibitrading.com",
        user_email: "admin@welcomehabibitrading.com",
        email_to: "admin@welcomehabibitrading.com",
        recipient: "admin@welcomehabibitrading.com",
        to_name: userData?.name || userData?.managerName || 'Manager',
        from_name: 'Welcome Habibi',
        verification_code: code,
        message: `Your verification code is: ${code}`,
        reply_to: "admin@welcomehabibitrading.com",
        // Investor details - matching EmailJS template variables
        deposit_name: selectedAckItem?.name || 'N/A',
        deposit_amount: selectedAckItem?.amount?.toLocaleString() || 'N/A',
      };

    

      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'origin': 'http://localhost'
        },
        body: JSON.stringify({
          service_id: EMAILJS_SERVICE_ID,
          template_id: EMAILJS_TEMPLATE_ID,
          user_id: EMAILJS_PUBLIC_KEY,
          template_params: templateParams
        })
      });

      // console.log('Response status:', response.status);
      const responseText = await response.text();
      // console.log('Response text:', responseText);

      if (response.ok || response.status === 200) {
        toast.success("Verification code sent to admin@welcomehabibitrading.com");
        setCodeSent(true);
      } else {
        console.error('EmailJS Error:', responseText);
        toast.error(`Email error: ${responseText}`);
        setCodeError(`Error: ${responseText}`);
      }
    } catch (error) {
      console.error('Error sending verification code:', error);
      toast.error('Network error. Check console for details.');
      setCodeError('Network error. Please try again.');
    } finally {
      setIsSendingCode(false);
    }
  };

  // Verify entered code
  const verifyCode = () => {
    setCodeError('');

    if (!enteredCode.trim()) {
      setCodeError('Please enter the verification code');
      return;
    }

    if (enteredCode.trim() === verificationCode) {
      setIsVerifying(true);
      setIsVerificationModalOpen(false);
      // Code is correct, proceed with acknowledge
      add_acknowledge(selectedAckItem?._id);
      setIsVerifying(false);
      // Reset states
      setVerificationCode('');
      setEnteredCode('');
      setSelectedAckItem(null);
      setCodeSent(false);
    } else {
      setCodeError('Invalid verification code. Please try again.');
    }
  };

  // Close verification modal
  const closeVerificationModal = () => {
    setIsVerificationModalOpen(false);
    setVerificationCode('');
    setEnteredCode('');
    setSelectedAckItem(null);
    setCodeSent(false);
    setCodeError('');
  };


  return (
    <Manager_web_portal
      language={
        <>
          <p className=" sm:block hidden">English | Urdu</p>
        </>
      }
      ToggleBtn={
        <div className=" flex gap-4 items-center">
          <HiOutlineArrowLeft />
          <h2 className="">Collection</h2>
        </div>
      }
      title_props={
        <>
          <div className=" w-96 relative">
            <Input
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={''}
              className={' border bg-white w-full rounded-full'}
            />

            <Button
              Icon={<IoSearchOutline className=" text-white text-xl" />}
              label={'search'}
              className={
                ' absolute top-0 right-0 bg-secondary  text-white uppercase font-normal rounded-full'
              }
            />
          </div>
        </>
      }
    >
      <div className="  w-full  mb-4  md:hidden block relative">
        <Input
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={''}
          className={' border bg-white w-full rounded-full'}
        />

        <Button
          Icon={<IoSearchOutline className=" text-white text-xl" />}
          label={'search'}
          className={
            ' absolute top-0 right-0 bg-secondary text-white uppercase font-normal rounded-full'
          }
        />
      </div>
      <div className=" sm:flex block relative    justify-between items-center">
        <div>
          <h2 className=" sm:block hidden">Collection</h2>
        </div>
        <Button
          label="Export to Excel"
          onClick={exportToExcel}
          className="ml-4 bg-secondary text-white uppercase font-normal rounded-full"
        />
        <ViewSlip isModalOpen={isModalOpen2} setIsModalOpen={setIsModalOpen2} getData={getData} />

        <div className=" ">
          <Button
            Icon={<VscFilter size={27} />}
            Icons={<GoTriangleDown />}
            label={'Select Filters'}
            onClick={toggleDropdown}
            className={' bg-white font-normal text-darkGray py-3 rounded-full'}
          />
          {dropdownVisible && (
            <div className="absolute z-10 p-3 mt-2 w-96 rounded-md shadow-lg bg-white right-0 ring-black ring-opacity-5">
              <div className="py-1 gap-4 flex">
                <div className=" py-2">
                  <label htmlFor="minValue" className="block text-sm font-medium text-gray-700">
                    Min Value
                  </label>
                  <Input
                    type="number"
                    id="minValue"
                    value={minValue}
                    onChange={(e) => setMinValue(e.target.value)}
                    className="mt-1 p-2 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
                <div className=" py-2">
                  <label htmlFor="maxValue" className="block text-sm font-medium text-gray-700">
                    Max Value
                  </label>
                  <Input
                    type="number"
                    id="maxValue"
                    value={maxValue}
                    onChange={(e) => setMaxValue(e.target.value)}
                    className="mt-1 p-2 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
                <div className="py-2">
                  <label htmlFor="maxValue" className="block text-sm font-medium text-gray-700">
                    Status
                  </label>
                  <select
                    id="status"
                    className="mt-2.5 p-2 bg-[#F6F6F6] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    onChange={(e) => setStatusFilter(e.target.value)}
                    value={statusFilter}
                  >
                    <option value="">All</option>
                    <option value={true}>Acknowledged</option>
                    <option value={false}>Acknowledge</option>
                  </select>
                </div>
              </div>

              {/* <Button
                onClick={handleSearch}
                label={"Search"}
                className={
                  "  bg-secondary rounded-full w-full justify-center text-white"
                }
              /> */}
            </div>
          )}
        </div>
      </div>
      <section className="mb-20 mt-7 text-gray-800">
        <div className="block rounded-lg ">
          <div className="flex overflow-hidden flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full mb-0">
                    <thead className=" ">
                      <tr className=" rounded-lg whitespace-nowrap ">
                        <th scope="col" className=" text-sm  text-darkGray  font-medium px-6">
                          Deposit Date
                        </th>
                        <th scope="col" className=" text-sm text-darkGray    font-medium px-6 ">
                          Name
                        </th>
                        <th scope="col" className=" text-sm text-darkGray   font-medium px-6 ">
                          CNIC No
                        </th>

                        <th scope="col" className="text-sm  text-darkGray   font-medium px-6 ">
                          Type
                        </th>

                        <th scope="col" className="text-sm  text-darkGray     font-medium px-6 ">
                          Receipt No
                        </th>
                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Amount
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Bank Name
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Branch
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Reference
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Remarks
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Ack. Auth.
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Ack Date
                        </th>

                        <th scope="col" className="text-sm    text-darkGray   font-medium px-6 ">
                          Slip
                        </th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {currentPageData?.map((item, index) => {
                        return (
                          <>
                            <tr className="bg-white border-8    border-[#F6F6F6]  rounded-md ">
                              <th
                                scope="row"
                                className="text-sm font-normal px-6 py-4   whitespace-nowrap "
                              >
                                <p className="mb-0.5 font-medium  text-secondary">
                                  {moment(item?.depositDate).format('DD/MM/YYYY')}
                                </p>
                              </th>
                              <td className="align-middle text-sm font-normal px-6 py-4 whitespace-nowrap  text-center">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline   bg-green-200  rounded-full">
                                  {item?.name}
                                </span>
                              </td>
                              <td className="text-sm font-normal text-center px-6 py-4 whitespace-nowrap">
                                <span className=" text-base  text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline   bg-green-200  rounded-full">
                                  {item?.cnic}
                                </span>
                              </td>
                              <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.depositType}{' '}
                                </span>
                              </td>
                              <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.receiptNumber}
                                </span>
                              </td>

                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.amount}
                                </span>
                              </td>
                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.bankName}
                                </span>
                              </td>
                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.branchName}
                                </span>
                              </td>
                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.reference}
                                </span>
                              </td>

                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.remark}
                                </span>
                              </td>

                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {item?.acknowledgeAuth}
                                </span>
                              </td>
                              <td className="align-middle  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                  {moment(item?.acknowledgeDate).format('DD/MM/YYYY')}
                                </span>
                              </td>

                              <td className="align-middle  cursor-pointer  text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span
                                  onClick={() => {
                                    openModal2();
                                    setGetData(item);
                                  }}
                                  className=" text-base  text-secondary  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full"
                                >
                                  {item?.slip.slice(-6)}{' '}
                                </span>
                              </td>

                              <td className="align-middle  cursor-pointer text-sm font-normal px-6 py-4 whitespace-nowrap">
                                {item?.acknowledgeStatus === true ? (
                                  <span className=" text-base cursor-not-allowed   text-green bg-lightGray   py-2 px-4 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                    Acknowledged{' '}
                                  </span>
                                ) : (
                                  <span
                                    onClick={() => handleAcknowledgeClick(item)}
                                    className=" text-base  flex   items-center gap-2  text-red bg-[#fdeced]  py-3 px-4 leading-none  whitespace-nowrap    bg-green-200  rounded-full"
                                  >
                                    Acknowledge
                                    {loading === item?._id ? (
                                      <svg
                                        className="animate-spin h-5 w-5 text-gray-700"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                      >
                                        <circle
                                          className="opacity-25"
                                          cx="12"
                                          cy="12"
                                          r="10"
                                          stroke="currentColor"
                                          strokeWidth="4"
                                        />
                                        <path
                                          className="opacity-75"
                                          fill="currentColor"
                                          d="M4 12a8 8 0 018-8v8H4z"
                                        />
                                      </svg>
                                    ) : (
                                      ''
                                    )}
                                  </span>
                                )}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <PaginationBar
            currentPage={currentPage}
            totalItems={filteredDeposits.length}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          />
        </div>
      </section>

      {/* Email Verification Modal */}
      {isVerificationModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-900">Email Verification</h3>
                <button
                  onClick={closeVerificationModal}
                  disabled={isSendingCode || isVerifying}
                  className="text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Deposit Info */}
              {selectedAckItem && (
                <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-medium text-gray-700 mb-2">Deposit Details</h4>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div>
                      <span className="text-gray-500">Name:</span>
                      <p className="font-medium">{selectedAckItem?.name}</p>
                    </div>
                    <div>
                      <span className="text-gray-500">Amount:</span>
                      <p className="font-medium">Rs. {selectedAckItem?.amount?.toLocaleString()}</p>
                    </div>
                    <div>
                      <span className="text-gray-500">CNIC:</span>
                      <p className="font-medium">{selectedAckItem?.cnic}</p>
                    </div>
                    <div>
                      <span className="text-gray-500">Receipt:</span>
                      <p className="font-medium">{selectedAckItem?.receiptNumber}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 1: Send Code */}
              {!codeSent ? (
                <div className="text-center">
                  <div className="mb-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <p className="text-gray-600 mb-2">
                      To acknowledge this deposit, we need to verify your identity.
                    </p>
                    <p className="text-sm text-gray-500">
                      A verification code will be sent to:
                    </p>
                    <p className="font-medium text-secondary mt-1">admin@welcomehabibitrading.com</p>
                  </div>

                  <button
                    onClick={sendVerificationCode}
                    disabled={isSendingCode}
                    className={`w-full py-3 px-4 rounded-lg text-white font-medium transition-colors ${isSendingCode
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-secondary hover:bg-primary'
                      }`}
                  >
                    {isSendingCode ? (
                      <span className="flex items-center justify-center gap-2">
                        <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        Sending Code...
                      </span>
                    ) : (
                      'Send Verification Code'
                    )}
                  </button>

                  {codeError && (
                    <p className="mt-3 text-sm text-red-600">{codeError}</p>
                  )}
                </div>
              ) : (
                /* Step 2: Enter Code */
                <div>
                  <div className="mb-4 text-center">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="text-gray-600 mb-1">
                      Verification code sent to:
                    </p>
                    <p className="font-medium text-secondary">admin@welcomehabibitrading.com</p>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Enter 6-digit verification code
                    </label>
                    <input
                      type="text"
                      value={enteredCode}
                      onChange={(e) => {
                        setEnteredCode(e.target.value.replace(/\D/g, '').slice(0, 6));
                        setCodeError('');
                      }}
                      placeholder="000000"
                      maxLength={6}
                      className="w-full px-4 py-3 text-center text-2xl font-bold tracking-widest border border-gray-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent outline-none"
                      autoFocus
                    />
                  </div>

                  {codeError && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <p className="text-sm text-red-600 flex items-center gap-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {codeError}
                      </p>
                    </div>
                  )}

                  <div className="flex gap-3">
                    <button
                      onClick={() => {
                        setCodeSent(false);
                        setEnteredCode('');
                        setCodeError('');
                      }}
                      disabled={isVerifying}
                      className="flex-1 py-3 px-4 rounded-lg text-gray-700 font-medium bg-gray-100 hover:bg-gray-200 transition-colors disabled:opacity-50"
                    >
                      Resend Code
                    </button>
                    <button
                      onClick={verifyCode}
                      disabled={isVerifying || enteredCode.length !== 6}
                      className={`flex-1 py-3 px-4 rounded-lg text-white font-medium transition-colors ${isVerifying || enteredCode.length !== 6
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-secondary hover:bg-primary'
                        }`}
                    >
                      {isVerifying ? (
                        <span className="flex items-center justify-center gap-2">
                          <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                          </svg>
                          Verifying...
                        </span>
                      ) : (
                        'Verify & Acknowledge'
                      )}
                    </button>
                  </div>

                  <p className="mt-4 text-xs text-gray-500 text-center">
                    Didn't receive the code? Check your spam folder or click "Resend Code"
                  </p>
                </div>
              )}

              {/* Cancel Button */}
              <button
                onClick={closeVerificationModal}
                disabled={isSendingCode || isVerifying}
                className="w-full mt-4 py-2 text-sm text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </Manager_web_portal>
  );
};

export default Collection;
